{
  "terminal-kubectl": {
    "name": "ghcr.io/highstate-io/highstate/terminal.kubectl",
    "tag": "latest",
    "image": "ghcr.io/highstate-io/highstate/terminal.kubectl:latest@sha256:2cd011119f6098d41b5bb377420f0106577d3b289ae4fc7982b4578b23c82ef4"
  },
  "worker.k8s-monitor": {
    "name": "ghcr.io/highstate-io/highstate/worker.k8s-monitor",
    "tag": "latest",
    "image": "ghcr.io/highstate-io/highstate/worker.k8s-monitor:latest@sha256:66b985a97925d39a4c6e2b15cbeefadaadfce0cb4d6e5df8881cca85281383d5"
  }
}
